import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'getDateTimeValue'
})
export class GetDateTimeValuePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(value: any, language: string = 'iv'): string {

    if (!value || !value[language]) {
      return '';
    }

    return this.datePipe.transform(value[language], "yyyy/MM/dd HH:mm:ss", "UTC -5");
  }
}
